<script>
  export default {
    mounted() {
      this.$root.botaoAcaoMostrar = false;
    }
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-atividade/componentes/SolicitacaoReembolsoAtividade.vue